import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, CalendarDays, Clock, Sparkles, Megaphone, BookOpen, CreditCard, LogOut, Video, Images, UserCog, KeyRound, Settings, ImageUp } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ButterflyIcon } from "../public/ButterflyIcon";

const NAV = [
  { to: "/admin", label: "Painel", icon: LayoutDashboard, end: true },
  { to: "/admin/clientes", label: "Clientes", icon: Users },
  { to: "/admin/agenda", label: "Agenda", icon: CalendarDays },
  { to: "/admin/disponibilidade", label: "Disponibilidade", icon: Clock },
  { to: "/admin/servicos", label: "Serviços & Pacotes", icon: Sparkles },
  { to: "/admin/campanhas", label: "Campanhas", icon: Megaphone },
  { to: "/admin/blog", label: "Caderno de Beleza", icon: BookOpen },
  { to: "/admin/depoimentos", label: "Depoimentos", icon: Video },
  { to: "/admin/resultados", label: "Antes & Depois", icon: Images },
  { to: "/admin/pagamentos", label: "Pagamentos", icon: CreditCard },
  { to: "/admin/midia", label: "Mídia do site", icon: ImageUp },
  { to: "/admin/equipe", label: "Equipe", icon: UserCog },
  { to: "/admin/configuracoes", label: "Configurações", icon: Settings },
  { to: "/admin/senha", label: "Alterar senha", icon: KeyRound },
];

export const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#F7F0E8] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#9B6179] text-[#F7F0E8] flex flex-col fixed inset-y-0">
        <div className="flex items-center gap-2.5 px-6 py-6 border-b border-white/10">
          <ButterflyIcon className="w-10" />
          <div>
            <p className="text-xs uppercase tracking-[0.3em] font-normal text-[#E8C47A]">Studio Carolina Aguiar</p>
            <p className="text-[10px] text-[#C5A059] uppercase tracking-widest">Painel Administrativo</p>
          </div>
        </div>
        <nav className="flex-1 py-4 space-y-1 px-3">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`admin-nav-${item.to.split("/").pop() || "dashboard"}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-[2px] text-sm transition-colors ${isActive ? "bg-[#090708] text-[#E8C47A]" : "text-[#F7F0E8]/70 hover:bg-white/5"}`
              }
            >
              <item.icon className="w-4 h-4" /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <p className="text-xs text-[#F7F0E8]/60 mb-2 truncate">{user?.email}</p>
          <button onClick={doLogout} data-testid="admin-logout-button" className="flex items-center gap-2 text-sm text-[#F7F0E8]/70 hover:text-[#E8C47A]">
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8">{children}</main>
    </div>
  );
};
